import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('add', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 20 20",
    width: props.size,
    height: props.size
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,5.5 C10.2454599,5.5 10.4496084,5.67687516 10.4919443,5.91012437 L10.5,6 L10.5,9.5 L14,9.5 C14.2761424,9.5 14.5,9.72385763 14.5,10 C14.5,10.2454599 14.3231248,10.4496084 14.0898756,10.4919443 L14,10.5 L10.5,10.5 L10.5,14 C10.5,14.2761424 10.2761424,14.5 10,14.5 C9.75454011,14.5 9.55039163,14.3231248 9.50805567,14.0898756 L9.5,14 L9.5,10.5 L6,10.5 C5.72385763,10.5 5.5,10.2761424 5.5,10 C5.5,9.75454011 5.67687516,9.55039163 5.91012437,9.50805567 L6,9.5 L9.5,9.5 L9.5,6 C9.5,5.72385763 9.72385763,5.5 10,5.5 Z",
    fill: props.colors[0],
    fillRule: "nonzero"
  }));
});